import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { NOT_STARTED, IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_CLIENTS } from '@/lib/constants/api'
import getClientModel from './models/client'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const client = {
  namespaced: true,
  state: {
    ...getClientModel()
  },
  getters: {
    getField,
    getClientObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    updateStatus,
    clearClient: (state) => {
      state.id = null
      state.businessEntityId = null
      state.active = null
      state.name = null
      state.createdBy = null
      state.invoiceFrequencyId = null
      state.invoiceFrequencyName = null
      state.thirdPartyPortalId = null
      state.clientStakeholderRecipients = []
      state.vmsFee = null
      state.contractorExpenses = []
      state.directPlacementsExpenses = []
      state.useStaffLynxForTimeEntering = false
      state.clientOfRecord = false
      state.quickBooksCustomerId = null
      state.quickBooksTimesheetItemId = null
      state.postToQuickBooksAutomatically = false
    },
    setClient: (state, client) => {
      state.id = client.id
      state.businessEntityId = client.businessEntityId
      state.active = client.active
      state.name = client.name
      state.createdBy = client.createdBy
      state.invoiceFrequencyId = client.invoiceFrequencyId
      state.invoiceFrequencyName = client.invoiceFrequencyName
      state.thirdPartyPortalId = client.thirdPartyPortalId
      state.clientStakeholderRecipients = client.clientStakeholderRecipients || []
      state.vmsFee = client.vmsFee
      state.contractorExpenses = client.contractorExpenses || []
      state.directPlacementsExpenses = client.directPlacementsExpenses || []
      state.useStaffLynxForTimeEntering = client.useStaffLynxForTimeEntering || false
      state.clientOfRecord = client.clientOfRecord || false
      state.quickBooksCustomerId = client.quickBooksCustomerId || null
      state.quickBooksTimesheetItemId = client.quickBooksTimesheetItemId || null
      state.postToQuickBooksAutomatically = client.postToQuickBooksAutomatically || false
    }
  },
  actions: {
    save ({ state }) {
      return api.doPost({ path: PATH_CLIENTS, data: state })
    },
    update ({ state }) {
      return api.doPut({ path: PATH_CLIENTS, data: state })
    },
    getClient: ({ commit, dispatch }, { id }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting client, please wait...' })

      return api.doGet({ path: PATH_CLIENTS, parameters: { id } })
        .then(json => json.data)
        .then(data => Array.isArray(data) ? data[0] : data)
        .then(client => {
          commit('updateStatus', { status: COMPLETE })
          commit('setClient', client)
          return client
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    saveClient: ({ state, commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving client, please wait...' })

      const actionName = state.id ? 'update' : 'save'

      return dispatch(actionName).then(response => {
        commit('updateStatus', { status: COMPLETE })

        if (!response.data) {
          throw new Error('Unable to save client. Check required fields.')
        }

        commit('clearClient')
        notifySuccess(dispatch, 'Client saved')
        return response
      }).catch((error) => {
        commit('updateStatus', { status: ERROR, error })
        notifyError(dispatch, 'Unable to save client. Try again later')

        throw error
      })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    clearClient: ({ commit }) => {
      commit('clearClient')
      return commit('updateStatus', { status: NOT_STARTED })
    }
  }
}

export default client
